module.exports = __webpack_public_path__ + "img/2024-04_experiential-learning.db7f13c9.jpg";